const tables = [
  {
    name: "Name",
  },
  {
    name: "Title",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
